var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "reset-password",
      attrs: {
        "align-center": "",
        "justify-center": "",
        role: "region",
        "aria-label": "Reset-password section",
      },
    },
    [
      _c(
        "v-flex",
        { attrs: { xs11: "", sm11: "", md11: "", md4: "", lg4: "" } },
        [
          _c(
            "v-card",
            { attrs: { color: "secondary", elevation: "2" } },
            [
              _c(
                "v-app-bar",
                { attrs: { flat: "" } },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass: "text-body-2",
                      attrs: { role: "heading", "aria-level": "1" },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("components.resetPassFinal.title")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function (ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      attrs: {
                                        small: "",
                                        color: "accent",
                                        "aria-label": _vm.$t(
                                          "components.resetPassFinal.buttons.signin"
                                        ),
                                        to: _vm.toSignInLink,
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "components.resetPassFinal.buttons.signin"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("components.resetPassFinal.buttons.signin")
                          )
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-container",
                { attrs: { fluid: "", "grid-list-md": "" } },
                [
                  _c("v-progress-linear", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isLoading,
                        expression: "isLoading",
                      },
                    ],
                    staticClass: "mb-4",
                    attrs: {
                      color: "accent",
                      indeterminate: "",
                      role: "status",
                      "aria-label": "Resetting your password—please wait",
                    },
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.filteredErrors, function (errorsGroup, idx) {
                    return _c(
                      "div",
                      {
                        key: idx,
                        attrs: { "aria-live": "assertive", role: "status" },
                      },
                      _vm._l(errorsGroup, function (error) {
                        return _c(
                          "v-alert",
                          {
                            key: error.id,
                            attrs: {
                              type: error.type,
                              icon: error.icon,
                              role: "alert",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(error.msg) +
                                "\n          "
                            ),
                          ]
                        )
                      }),
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "v-form",
                    {
                      attrs: {
                        role: "form",
                        "aria-labelledby": "reset-password-heading",
                      },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.validate($event)
                        },
                      },
                    },
                    [
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|email|min:6|max:255",
                                    expression:
                                      "'required|email|min:6|max:255'",
                                  },
                                ],
                                attrs: {
                                  "prepend-icon": "fal fa-envelope",
                                  color: "accent",
                                  "data-vv-name": "email",
                                  label:
                                    _vm.$t(
                                      "components.resetPassFinal.form.email"
                                    ) + " *",
                                  "error-messages": _vm.errors.collect("email"),
                                  name: "email",
                                  autocomplete: "email",
                                  type: "email",
                                  "aria-required": "true",
                                },
                                model: {
                                  value: _vm.form.email,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "email", $$v)
                                  },
                                  expression: "form.email",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|min:6|max:50",
                                    expression: "'required|min:6|max:50'",
                                  },
                                ],
                                ref: "newPassword",
                                attrs: {
                                  "prepend-icon": "fal fa-key",
                                  color: "accent",
                                  "data-vv-name": "newPassword",
                                  label:
                                    _vm.$t(
                                      "components.resetPassFinal.form.password"
                                    ) + " *",
                                  "error-messages":
                                    _vm.errors.collect("newPassword"),
                                  name: "newPassword",
                                  type: "password",
                                  autocomplete: "new-password",
                                  "aria-required": "true",
                                },
                                model: {
                                  value: _vm.form.newPassword,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "newPassword", $$v)
                                  },
                                  expression: "form.newPassword",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      "required|min:6|max:50|confirmed:newPassword",
                                    expression:
                                      "'required|min:6|max:50|confirmed:newPassword'",
                                  },
                                ],
                                attrs: {
                                  "prepend-icon": "fal fa-key",
                                  color: "accent",
                                  "data-vv-name": "confirmNewPassword",
                                  label:
                                    _vm.$t(
                                      "components.resetPassFinal.form.confirmPass"
                                    ) + " *",
                                  "error-messages":
                                    _vm.errors.collect("confirmNewPassword"),
                                  name: "confirmNewPassword",
                                  type: "password",
                                  autocomplete: "new-password",
                                  "aria-required": "true",
                                },
                                model: {
                                  value: _vm.form.confirmNewPassword,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "confirmNewPassword",
                                      $$v
                                    )
                                  },
                                  expression: "form.confirmNewPassword",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "accent",
                                type: "submit",
                                "aria-label": _vm.$t(
                                  "components.resetPassFinal.buttons.reset"
                                ),
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "components.resetPassFinal.buttons.reset"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }